import axios from 'axios';
import Cookies from 'js-cookie';

export const request = (method, url) => {
  const payload = Cookies.getJSON('POP_SESSION');
  const { access_token } = payload;

  const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${access_token}`,
  };

  return axios({
    method,
    url,
    headers,
  });
};
